// 🚀 TEZLAA URLs - Updated for real API

const AppURLs = {
  // 🌐 Frontend URL
  FRONTEND: "http://localhost:3000",

  // 🔗 Backend URL
  BACKEND:
    import.meta.env.VITE_BACKEND_URL,

  // 📡 API URL (automatically uses backend)
  get API() {
    return `${this.BACKEND}/api/v1`;
  },

  // 🔌 Socket URL (automatically uses backend)
  get SOCKET() {
    return this.BACKEND;
  },

  // 🔐 Auth endpoints
  AUTH: {
    LOGIN: "/auth/login",
    LOGOUT: "/auth/logout",
    REFRESH: "/auth/refresh-tokens",
    REGISTER: "/auth/register",
  },

  BRANCHES: {
    GET_ALL: "/branches",
    GET_BY_ID: "/branches/:id",
    CREATE: "/branches",
    UPDATE: "/branches/:id",
    DELETE: "/branches/:id",
  },

  // 👥 User endpoints
  USERS: {
    GET_ALL: "/auth/users",
    GET_BY_ID: "/auth/users/:id",
    CREATE: "/auth/register",
    UPDATE: "/auth/users/:id",
    DELETE: "/auth/users/:id",
    RESET_PASSWORD: "/auth/users/:id/reset-password",
    TOGGLE_STATUS: "/auth/users/:id/status",
  },

  // 📦 Category endpoints
  CATEGORIES: {
    GET_ALL: "/categories",
    GET_BY_ID: "/categories/:id",
    CREATE: "/categories",
    UPDATE: "/categories/:id",
    DELETE: "/categories/:id",
    VALIDATE_NAME: "/categories/validate-name",
    BULK_DELETE: "/categories/bulk-delete",
    BULK_STATUS: "/categories/bulk-status",
    STATS: "/categories/stats",
  },

  // 📏 Units endpoints
  UNITS: {
    GET_ALL: "/units",
    GET_BY_ID: "/units/:id",
    CREATE: "/units",
    UPDATE: "/units/:id",
    DELETE: "/units/:id",
    VALIDATE_NAME: "/units/validate-name",
    BULK_DELETE: "/units/bulk-delete",
    BULK_STATUS: "/units/bulk-status",
    STATS: "/units/stats",
  },

  // 🧱 Raw Materials endpoints
  RAW_MATERIALS: {
    GET_ALL: "/raw-materials",
    GET_BY_ID: "/raw-materials/:id",
    CREATE: "/raw-materials",
    UPDATE: "/raw-materials/:id",
    DELETE: "/raw-materials/:id",
    VALIDATE: "/raw-materials/validate",
    VALIDATE_NAME: "/raw-materials/validate-name",
    VALIDATE_CODE: "/raw-materials/validate-code",
    BULK_DELETE: "/raw-materials/bulk-delete",
    BULK_STATUS: "/raw-materials/bulk-status",
    STATS: "/raw-materials/stats",
    LOW_STOCK: "/raw-materials/low-stock",
    BY_UNIT: "/raw-materials/by-unit/:unitId",
    SEARCH: "/raw-materials/search",
  },

  // 🛍️ Products endpoints
  PRODUCTS: {
    GET_ALL: "/products",
    GET_BY_ID: "/products/:id",
    CREATE: "/products",
    UPDATE: "/products/:id",
    DELETE: "/products/:id",
    VALIDATE_NAME: "/products/validate-name",
    VALIDATE_SKU: "/products/validate-sku",
    BULK_DELETE: "/products/bulk-delete",
    BULK_STATUS: "/products/bulk-status",
    STATS: "/products/stats",
    BY_CATEGORY: "/products/by-category/:categoryId",
    BY_TYPE: "/products/by-type/:type",
    SEARCH: "/products/search",
    CHECK_ASSIGNMENT: "/products/:id/check-assignment",
  },

  // 📦 Raw Material Inventory endpoints
  RAW_MATERIAL_INVENTORIES: {
    GET_ALL: "/raw-material-inventories",
    GET_BY_ID: "/raw-material-inventories/:id",
    CREATE: "/raw-material-inventories",
    CREATE_MULTIPLE: "/raw-material-inventories/multiple",
    UPDATE: "/raw-material-inventories/:id",
    DELETE: "/raw-material-inventories/:id",
    UNASSIGNED: "/raw-material-inventories/unassigned-raw-materials/:branchId",
    BY_BRANCH: "/raw-material-inventories/branch/:branchId",
    BY_MATERIAL: "/raw-material-inventories/material/:materialId",
    LOW_STOCK: "/raw-material-inventories/low-stock",
    STATS: "/raw-material-inventories/stats",
  },

  // 📦 Product Inventory endpoints
  PRODUCT_INVENTORIES: {
    GET_ALL: "/product-inventories",
    GET_BY_ID: "/product-inventories/:id",
    CREATE: "/product-inventories",
    CREATE_MULTIPLE: "/product-inventories/multiple",
    UPDATE: "/product-inventories/:id",
    DELETE: "/product-inventories/:id",
    UNASSIGNED: "/product-inventories/unassigned-products/:branchId",
    BY_BRANCH: "/product-inventories/branch/:branchId",
    BY_PRODUCT: "/product-inventories/product/:productId",
    LOW_STOCK: "/product-inventories/low-stock",
    STATS: "/product-inventories/stats",
  },

  // 🍴 Recipes endpoints
  RECIPES: {
    GET_ALL: "/recipes",
    GET_BY_ID: "/recipes/:id",
    CREATE: "/recipes",
    UPDATE: "/recipes/:id",
    DELETE: "/recipes/:id",
    VALIDATE_NAME: "/recipes/validate-name",
    BULK_DELETE: "/recipes/bulk-delete",
    BULK_STATUS: "/recipes/bulk-status",
    STATS: "/recipes/stats",
    BY_PRODUCT: "/recipes/by-product/:productId",
    SEARCH: "/recipes/search",
  },

  // 🏢 Suppliers endpoints
  SUPPLIERS: {
    GET_ALL: "/suppliers",
    GET_BY_ID: "/suppliers/:id",
    CREATE: "/suppliers",
    UPDATE: "/suppliers/:id",
    DELETE: "/suppliers/:id",
    VALIDATE_NAME: "/suppliers/validate-name",
    VALIDATE_MOBILE: "/suppliers/validate-mobile",
    VALIDATE_EMAIL: "/suppliers/validate-email",
    BULK_DELETE: "/suppliers/bulk-delete",
    BULK_STATUS: "/suppliers/bulk-status",
    STATS: "/suppliers/stats",
    SEARCH: "/suppliers/search",
  },

  // 🛒 Purchase Orders endpoints
  PURCHASE_ORDERS: {
    GET_ALL: "/purchase-orders",
    GET_BY_ID: "/purchase-orders/:id",
    CREATE: "/purchase-orders",
    UPDATE: "/purchase-orders/:id",
    DELETE: "/purchase-orders/:id",
    SUPPLIERS_WAREHOUSES: "/purchase-orders/suppliers-warehouses",
  },

  GRN: {
    GET_ALL: "/goods-receipt-notes",
    GET_BY_ID: "/goods-receipt-notes/:id",
    CREATE: "/goods-receipt-notes",
    UPDATE: "/goods-receipt-notes/:id",
    DELETE: "/goods-receipt-notes/:id",
    GET_PURCHASE_ORDERS: "/purchase-orders", // For getting available POs
    STATS: "/goods-receipt-notes/stats",
  },

  // 💰 GRN Payments endpoints
  GRN_PAYMENTS: {
    GET_ALL: "/grn-payments",
    GET_BY_ID: "/grn-payments/:id",
    CREATE: "/grn-payments",
    UPDATE: "/grn-payments/:id",
    DELETE: "/grn-payments/:id",
    GET_BY_GRN: "/grn-payments/grn/:grnId",
    STATS: "/grn-payments/stats",
  },
  // 🚨 Stock Alerts endpoints
  STOCK_ALERTS: {
    GET_ALL: "/stock-alerts",
    BY_BRANCH: "/stock-alerts?branch=:branchId",
    STATS: "/stock-alerts/stats",
    SUMMARY: "/stock-alerts/summary",
  },

  // 🪑 Tables endpoints
  TABLES: {
    GET_ALL: "/tables",
    GET_BY_ID: "/tables/:id",
    CREATE: "/tables",
    UPDATE: "/tables/:id",
    DELETE: "/tables/:id",
    VALIDATE_NUMBER: "/tables/validate-number",
    BULK_DELETE: "/tables/bulk-delete",
    BULK_STATUS: "/tables/bulk-status",
    STATS: "/tables/stats",
    BY_BRANCH: "/tables/branch/:branchId",
    BY_AVAILABILITY: "/tables/availability/:availability",
    SEARCH: "/tables/search",
  },

  // 👥 Customers endpoints
  CUSTOMERS: {
    GET_ALL: "/customers",
    GET_BY_ID: "/customers/:id",
    CREATE: "/customers",
    UPDATE: "/customers/:id",
    DELETE: "/customers/:id",
    VALIDATE_NAME: "/customers/validate-name",
    VALIDATE_MOBILE: "/customers/validate-mobile",
    BULK_DELETE: "/customers/bulk-delete",
    BULK_STATUS: "/customers/bulk-status",
    STATS: "/customers/stats",
    BY_BRANCH: "/customers/branch/:branchId",
    BY_STATUS: "/customers/status/:status",
    SEARCH: "/customers/search",
    BY_MOBILE: "/customers/mobile/:mobileNumber",
  },

  // 👥 Customer Groups endpoints
  CUSTOMER_GROUPS: {
    GET_ALL: "/customer-groups",
    GET_BY_ID: "/customer-groups/:id",
    CREATE: "/customer-groups",
    UPDATE: "/customer-groups/:id",
    DELETE: "/customer-groups/:id",
    VALIDATE_NAME: "/customer-groups/validate-name",
    BULK_DELETE: "/customer-groups/bulk-delete",
    BULK_STATUS: "/customer-groups/bulk-status",
    STATS: "/customer-groups/stats",
    BY_STATUS: "/customer-groups/status/:status",
    SEARCH: "/customer-groups/search",
    ADD_CUSTOMERS: "/customer-groups/:id/customers",
    REMOVE_CUSTOMERS: "/customer-groups/:id/customers/remove",
  },

  // 🎉 Promotions endpoints
  PROMOTIONS: {
    GET_ALL: "/promotions",
    GET_BY_ID: "/promotions/:id",
    CREATE: "/promotions",
    UPDATE: "/promotions/:id",
    DELETE: "/promotions/:id",
    VALIDATE_NAME: "/promotions/validate-name",
    BULK_DELETE: "/promotions/bulk-delete",
    BULK_STATUS: "/promotions/bulk-status",
    STATS: "/promotions/stats",
    BY_TYPE: "/promotions/type/:promotionType",
    BY_STATUS: "/promotions/status/:status",
    ACTIVE: "/promotions/active",
    SEARCH: "/promotions/search",
  },

  // 📱 SMS Campaigns endpoints
  SMS_CAMPAIGNS: {
    GET_ALL: "/sms-campaigns",
    GET_BY_ID: "/sms-campaigns/:id", 
    CREATE: "/sms-campaigns",
    UPDATE: "/sms-campaigns/:id",
    DELETE: "/sms-campaigns/:id",
    RUN: "/sms-campaigns/:id/run",
    RETRY: "/sms-campaigns/:id/retry",
    LOGS: "/sms-logs",
    STATS: "/sms-campaigns/stats",
    BULK_DELETE: "/sms-campaigns/bulk-delete",
    BY_STATUS: "/sms-campaigns/status/:status",
  },

  // 🛍️ Orders endpoints  
  ORDERS: {
    GET_ALL: "/orders",
    GET_BY_ID: "/orders/:id",
    CREATE: "/orders",
    UPDATE: "/orders/:id",
    DELETE: "/orders/:id",
    UPDATE_STATUS: "/orders/:id/status",
    CANCEL: "/orders/:id/cancel",
    BY_BRANCH: "/orders/branch/:branchId",
    BY_CUSTOMER: "/orders/customer/:customerId",
    BY_STATUS: "/orders/status/:status",
    BY_TYPE: "/orders/type/:orderType",
    PENDING: "/orders/pending",
    STATS: "/orders/stats",
    SEARCH: "/orders/search",
    RECEIPT: "/orders/:id/receipt",
    EXPORT: "/orders/export",
  },

  // ☕ Barista Orders endpoints
  BARISTA_ORDERS: {
    GET_ALL: "/barista-orders",
    GET_BY_ID: "/barista-orders/:id",
    UPDATE_STATUS: "/barista-orders/:id",
  },

  // 💰 Shift Cash Balance endpoints
  SHIFTS: {
    GET_ALL: "/shift-cash-balances",
    GET_BY_ID: "/shift-cash-balances/:id",
    CREATE: "/shift-cash-balances",
    UPDATE: "/shift-cash-balances/:id",
    CLOSE: "/shift-cash-balances/:id",
  },

  // ⚙️ System Configuration endpoints
  SYSTEM_CONFIGS: {
    GET_ALL: "/system-configs",
    GET_BY_KEY: "/system-configs/:key",
    UPDATE: "/system-configs/:id",
    CREATE: "/system-configs",
    DELETE: "/system-configs/:id",
  },

  // 💰 Service Charge Report endpoint
  SERVICE_CHARGE_REPORT: {
    GET: "/service-charge-report",
  },
};

export default AppURLs;
